<h3 class="ui primary header">
  {{
    viewTerms
      ? "Terms and Condition"
      : "Activate " +
        capitalize(modal.context.account?.currencyShortName) +
        " eWallet Account"
  }}
  <i
    class="link times icon"
    *ngIf="!viewTerms"
    (click)="modal.deny(undefined)"
  ></i>
  <i class="link times icon" *ngIf="viewTerms" (click)="disagreeToTerms()"></i>
</h3>

<esl-message-toast [(message)]="error"></esl-message-toast>
<esl-message-toast
  [(message)]="success"
  [messageType]="'success'"
></esl-message-toast>

<div class="content">
  <div
    class="ui basic vertical segment"
    [ngClass]="{ loading: banks == undefined }"
    *ngIf="viewTerms"
    [innerHTML]="terms"
  ></div>
  <div
    class="ui basic vertical segment"
    [ngClass]="{ loading: banks == undefined }"
    *ngIf="!viewTerms"
  >
    <div class="ui form">
      <h4>Fill in your Bank Account details here</h4>

      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="modal.context.account.currencyShortName.includes('DOLLAR')"
      >
        <label>Beneficiary Name<span class="required-text">*</span></label>
        <div class="ui fluid input">
          <input
            type="text"
            placeholder="Enter beneficiary name"
            [(ngModel)]="accountName"
          />
        </div>
      </div>

      <div class="field" appMargin marginB="15px">
        <label
          >{{
            modal.context.account.currencyShortName.includes("DOLLAR")
              ? "Banking Institution"
              : "Bank"
          }}<span class="required-text">*</span></label
        >
        <div class="ui fluid input">
          <sui-select
            class="fluid selection"
            placeholder="Select Bank"
            [options]="banks"
            [isSearchable]="true"
            labelField="optionName"
            [(ngModel)]="selectedBank"
            *ngIf="!modal.context.account.currencyShortName.includes('DOLLAR')"
            #select
          >
            <sui-select-option
              *ngFor="let option of select.filteredOptions"
              [value]="option"
            >
            </sui-select-option>
          </sui-select>

          <input
            type="text"
            *ngIf="modal.context.account.currencyShortName.includes('DOLLAR')"
            placeholder="Enter Bank Name"
            [(ngModel)]="selectedBank"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        *ngIf="!modal.context.account.currencyShortName.includes('DOLLAR')"
      >
        <label>Account Name<span class="required-text">*</span></label>
        <div class="ui fluid input">
          <input
            type="text"
            [(ngModel)]="accountName"
            placeholder="Enter account name"
          />
        </div>
      </div>

      <div class="field" appMargin marginB="15px">
        <label>Account Number<span class="required-text">*</span></label>
        <div class="ui fluid input">
          <input
            type="text"
            inputmode="numeric"
            pattern="[0-9]{5,12}"
            [(ngModel)]="accountNumber"
            placeholder="Enter account number"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        style="padding-bottom: 8px"
        *ngIf="modal.context.account.currencyShortName.includes('DOLLAR')"
      >
        <span class="currency-symbol">{{ row.currencyCode }}</span>
        <span class="currency-name">US Dollar</span>
      </div>
      <div
        class="field"
        appMargin
        marginB="15px"
        style="padding-bottom: 8px"
        *ngIf="modal.context.account.currencyShortName.includes('DOLLAR')"
      >
        <label
          >IBAN/Routing Number (Minimum of 5 digits and maximum of 12
          digit)</label
        >
        <div class="ui fluid input">
          <input
            type="text"
            inputmode="numeric"
            pattern="[0-9]{5,12}"
            placeholder="Enter IBAN"
            [(ngModel)]="ibanNumber"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        style="padding-bottom: 8px"
        *ngIf="modal.context.account.currencyShortName.includes('DOLLAR')"
      >
        <label>SWIFT or Sort Code (e.g 12-34-56)</label>
        <div class="ui fluid input">
          <input
            type="text"
            pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
            placeholder="Enter swift code"
            [(ngModel)]="sortCode"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        style="padding-bottom: 8px"
        *ngIf="modal.context.account.currencyShortName.includes('DOLLAR')"
      >
        <label>Intermediary Bank SWIFT Code (e.g 12-34-56)</label>
        <div class="ui fluid input">
          <input
            type="text"
            pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
            placeholder="Enter intermediary bank swift code"
            [(ngModel)]="intermediaryBankSwiftCode"
          />
        </div>
      </div>

      <div
        class="field"
        appMargin
        marginB="15px"
        style="padding-bottom: 8px"
        *ngIf="modal.context.account.currencyShortName.includes('DOLLAR')"
      >
        <label>Bank Physical Address</label>
        <div class="ui fluid input">
          <input
            type="text"
            placeholder="Enter bank address"
            [(ngModel)]="bankAddress"
          />
        </div>
      </div>

      <div class="field">
        <sui-checkbox class="custom-checkbox" [(ngModel)]="agreementAccepted">
          <h4
            class="ui primary header"
            style="
              font-family: Roboto;
              font-size: 14px;
              font-weight: 500;
              line-height: 22px;
              letter-spacing: 0px;
              text-align: center;
            "
          >
            I agree to all
            <span class="tandc" (click)="openTAndC($event)"
              >terms and conditions</span
            >
          </h4>
        </sui-checkbox>
      </div>
    </div>
  </div>

  <div
    class="actions"
    style="background: transparent; border: none"
    *ngIf="!viewTerms"
  >
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <button
      class="ui primary button"
      (click)="activateAccount()"
      [disabled]="
        !accountName || !accountNumber || !selectedBank || !agreementAccepted
      "
      [ngClass]="{ loading: pending }"
      autofocus
    >
      Activate
      {{ capitalize(modal.context.account?.currencyShortName) }} eWallet Account
    </button>
  </div>
  <div
    class="actions"
    style="background: transparent; border: none"
    *ngIf="viewTerms"
  >
    <button class="ui basic primary button" (click)="disagreeToTerms()">
      I disagree
    </button>
    <button class="ui primary button" (click)="agreeToTerms()" autofocus>
      I have read and accepted the terms
    </button>
  </div>
</div>
